import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG, Settings } from 'src/app/config/settings';
import { combine } from 'src/app/shared/utilities/route';
import { LocumsMarginCalculatorSlice } from '../store/locums-margin-calculator.slice';
import { mapSliceToSaveRequest } from '../helpers/locums-margin-calculator.helper';
import { MarginDetails } from '../models/margin-details.model';

@Injectable({ providedIn: 'root' })
export class LocumsMarginCalculatorService {
    private readonly coreApiPath: string;

    constructor(
        private readonly http: HttpClient,
        @Inject(APP_CONFIG) settings: Settings
    ) {
        this.coreApiPath = combine(settings.coreAPIUrl, 'ayanova');
    }

    saveMarginDetails(data: LocumsMarginCalculatorSlice): Observable<number> {
        const saveRequest = mapSliceToSaveRequest(data);

        const url = combine(this.coreApiPath, `locums/margins/save`);
        return this.http.post<number>(url, saveRequest);
    }

    getMarginDetails(marginId: number): Observable<MarginDetails> {
        const url = combine(this.coreApiPath, `locums/margins/${marginId}`);
        return this.http.get<MarginDetails>(url);
    }

    getDuplicateMarginId(candidateId: number, jobId: number): Observable<number> {
        const url = combine(
            this.coreApiPath,
            `locums/margins/duplicate-margin-id?candidateId=${candidateId}&jobId=${jobId}`
        );
        return this.http.get<number>(url);
    }

    showCreatePresentation(marginId: number): Observable<boolean> {
        const url = combine(this.coreApiPath, `locums/margins/${marginId}/show-create-presentation-cta`);
        return this.http.get<boolean>(url);
    }
}
